export default __webpack_public_path__ + "static/media/total_icon.2693b085.svg";